import { ref } from "vue";
export function useAutoScrollControl() {
    // Use local state instead of global to prevent conflicts between multiple chat instances
    const skipScroll = ref(false);
    function preventNextAutoScroll() {
        skipScroll.value = true;
    }
    function shouldSkipScroll() {
        if (skipScroll.value) {
            skipScroll.value = false;
            return true;
        }
        return false;
    }
    return {
        preventNextAutoScroll,
        shouldSkipScroll
    };
}
